export default __webpack_public_path__ + "static/media/ITR-77.117847ea.png";